export const defaultStrokeStyles = [
  { className: 'linestyle-image', key: 'solid', src: 'icon-linestyle-solid-line' },
  { className: 'linestyle-image shift-alignment', key: 'dash,2,2', src: 'icon-linestyle-dash-2-2' },
  { className: 'linestyle-image shift-alignment', key: 'dash,4,4', src: 'icon-linestyle-dash-4-4' },
  { className: 'linestyle-image shift-alignment', key: 'dash,6,6', src: 'icon-linestyle-dash-6-6' },
  { className: 'linestyle-image shift-alignment', key: 'dash,1,4,8,4', src: 'icon-linestyle-dash-1-4-8-4' },
  { className: 'linestyle-image shift-alignment', key: 'dash,3,6,10,6', src: 'icon-linestyle-dash-3-6-10-6' },
  { className: 'linestyle-image shift-alignment', key: 'dash,4,6,10,6', src: 'icon-linestyle-dash-4-6-10-6' },
];

export const cloudyStrokeStyle = { className: 'linestyle-image shift-alignment', key: 'cloudy', src: 'icon-linestyle-cloudy-line' };